import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import styles from './../../Assets/CSS/Style.module.css';
import inputStyles from './../../Assets/CSS/Input.module.css';
import { BlueButton } from './../../Components/Button';
import axios from 'axios';
import { BASE_URL } from './../../Environment';
import { toast } from 'react-toastify';
import Info from './Info';

function VideoPost() {
    const accessToken = localStorage.getItem('accessToken');
    const [isLoading, setIsLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [vendorId, setVendorId] = useState(null);
    const [formData, setFormData] = useState({
        title: '',
        sub_title: '',
        link: '',
        video_category_id: ''
    });
    
    useEffect(() => {
        document.title = 'Infomart | Client Post Video';
        fetchVendorDetails();
        fetchCategories();
    }, []);
    
    const fetchVendorDetails = () => {
        setIsLoading(true);
        axios.get(`${BASE_URL}/vendor/details`, {
            headers: { 
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setVendorId(res.data.data.id);
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
    };
    
    const fetchCategories = () => {
        axios.get(`${BASE_URL}/video-category`, {
            headers: { 
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            setCategories(res.data.data);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
        });
    };
    
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };
    
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!vendorId) {
            toast.error('Unable to get vendor details', { autoClose: 3000 });
            return;
        }
        
        setIsSubmitLoading(true);
        
        await axios.post(`${BASE_URL}/video/post`, {
            upload_by: 'Client',
            upload_id: vendorId,
            title: formData.title,
            sub_title: formData.sub_title,
            link: formData.link,
            video_category_id: formData.video_category_id
        }, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            toast.success(res.data.msg, { autoClose: 3000 });
            setFormData({
                title: '',
                sub_title: '',
                link: '',
                video_category_id: ''
            });
            setIsSubmitLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsSubmitLoading(false);
        });
    };
    
    return (
        <div className="app">
            <div className="outlet">
                <Info />
                <div className="homeLayout">
                    <Sidebar />
                    {isLoading ?
                        <h5 className="text-center mt-5">Loading...</h5>
                    :
                        <div className={styles.profilePageContainer}>
                            <div className={styles.leftSection}>
                                <h4 className="mb-0">Post Video</h4>
                                <div className={styles.accountDetailsBox}>
                                    <div className={styles.boxHead}>Video Information</div>
                                    <div className={`${styles.accountDetailsInner} p-4`}> 
                                        <form onSubmit={handleSubmit}>
                                            <div className={styles.inputs}>
                                                <input 
                                                    type="text" 
                                                    className={inputStyles.input} 
                                                    name="title"
                                                    value={formData.title}
                                                    placeholder="Enter Video Title *"
                                                    onChange={handleChange}
                                                    required
                                                />
                                                <input 
                                                    type="text" 
                                                    className={inputStyles.input} 
                                                    name="sub_title"
                                                    value={formData.sub_title}
                                                    placeholder="Enter Video Sub Title *"
                                                    onChange={handleChange}
                                                    required
                                                />
                                                <input 
                                                    type="url" 
                                                    className={inputStyles.input} 
                                                    name="link"
                                                    value={formData.link}
                                                    placeholder="Enter YouTube Link (https://www.youtube.com/watch?v=...) *"
                                                    onChange={handleChange}
                                                    required
                                                />
                                                <select 
                                                    className={inputStyles.dropdown} 
                                                    name="video_category_id"
                                                    value={formData.video_category_id}
                                                    onChange={handleChange}
                                                    required
                                                >
                                                    <option value="" disabled>Select Category *</option>
                                                    {categories.map((category) => (
                                                        <option key={category.id} value={category.id}>
                                                            {category.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="mt-3">
                                                <BlueButton 
                                                    type="submit"
                                                    title={isSubmitLoading ? "Posting..." : "Post Video"} 
                                                    disabled={isSubmitLoading}
                                                />
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default VideoPost; 